// import { RouterModule, Routes } from '@angular/router';
// import { NgModule } from '@angular/core';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from './demo/service/auth.guard';
import { OwnershipGuard } from './demo/components/auth/authentication/ownership.guard';
import { PermissionGuard } from './demo/components/auth/authentication/permission.guard';
import { UserProfileComponent } from './demo/sharing/components/user-profile/user-profile.component';
import { AdminAuthGuard } from './demo/components/auth/authentication/admin-auth.guard';
import { ParentAuthGuard } from './demo/components/auth/authentication/parent-auth.guard';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { LoginComponent } from './demo/components/auth/authentication/login.component';
import { ForgotPasswordComponent } from './demo/components/auth/authentication/forgot-password.component';
import { ResetPasswordComponent } from './demo/components/auth/authentication/reset-password.component';
import { VerifyEmailChangeComponent } from './demo/components/auth/authentication/verify-email-change.component';
import { NewPasswordComponent } from './demo/components/auth/authentication/new-password/new-password.component';
import { AuthRedirectGuard } from './demo/components/auth/guards/auth-redirect.guard';

const routes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./demo/components/dashboards/dashboards.module').then(
                        (m) => m.DashboardsModule,
                    ),
                canActivate: [AuthGuard],
            },
            {
                path: 'profile',
                data: { breadcrumb: 'User Management' },
                loadChildren: () =>
                    import('./demo/components/profile/profile.module').then(
                        (m) => m.ProfileModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'apps',
                data: { breadcrumb: 'Apps' },
                loadChildren: () =>
                    import('./demo/components/apps/apps.module').then(
                        (m) => m.AppsModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'myschool',
                loadChildren: () =>
                    import('./demo/components/myschool/myschool.module').then(
                        (m) => m.MyschoolModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'billings/accounting/familylayout/:id',
                data: { breadcrumb: 'Family Layout' },
                loadChildren: () =>
                    import('./demo/components/billing/accounting/family-layout/family-layout.module').then(
                        (m) => m.FamilyLayoutModule,
                    ),
                canActivate: [AuthGuard, ParentAuthGuard, OwnershipGuard],
            },
            {
                path: 'billing',
                loadChildren: () =>
                    import('./demo/components/billing/billing.module').then(
                        (m) => m.BillingModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'staff',
                data: { breadcrumb: 'Staff' },
                loadChildren: () =>
                    import('./demo/components/staff-management/staff-management.module').then(
                        (m) => m.StaffManagementModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'student-Sign-In',
                loadChildren: () =>
                    import('./demo/components/student-sign-in/student-sign-in.module').then(
                        (m) => m.StudentSignInModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'settings',
                loadChildren: () =>
                    import('./demo/components/school-setting/school-setting.module').then(
                        (m) => m.SchoolSettingModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'staffSignin',
                loadChildren: () =>
                    import('./demo/components/staff-management/staff-signin/staff-signin.module').then(
                        (m) => m.StaffSigninModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'gen-settings',
                loadChildren: () =>
                    import('./demo/components/settings/settings.module').then(
                        (m) => m.SettingsModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'rolePermission',
                data: { breadcrumb: 'Roles & Permissions' },
                loadChildren: () =>
                    import('./demo/components/settings/role-permission/role-permission.module').then(
                        (m) => m.RolePermissionModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'parentConnection',
                loadChildren: () =>
                    import('./demo/components/parent-connection/parent-connection.module').then(
                        (m) => m.ParentConnectionModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'scheduling',
                loadChildren: () =>
                    import('./demo/components/scheduling/scheduling.module').then(
                        (m) => m.SchedulingModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'calendar-event',
                data: { breadcrumb: 'Calendar' },
                loadChildren: () =>
                    import('./demo/components/calendar-event/calendar-event.module').then(
                        (m) => m.CalendarEventModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'reports',
                loadChildren: () =>
                    import('./demo/components/reports/reports.module').then(
                        (m) => m.ReportsModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'future-enrollment',
                data: { breadcrumb: 'Availability' },
                loadChildren: () =>
                    import('./demo/components/future-enrollment/future-enrollment.module').then(
                        (m) => m.FutureEnrollmentModule,
                    ),
                canActivate: [AuthGuard, PermissionGuard],
            },
            {
                path: 'user-profile/profile',
                data: { breadcrumb: 'My Profile' },
                component: UserProfileComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'communication',
                loadChildren: () =>
                    import('./demo/components/communication/communication.module').then(
                        (m) => m.CommunicationModule,
                    ),
                canActivate: [AuthGuard],
            },
        ],
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [AuthRedirectGuard],
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [AuthRedirectGuard],
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [AuthRedirectGuard],
    },
    {
        path: 'verify-email-change',
        component: VerifyEmailChangeComponent,
    },
    {
        path: 'new-password',
        component: NewPasswordComponent,
        canActivate: [AuthRedirectGuard],
    },
    {
        path: 'landing',
        loadChildren: () =>
            import('./demo/components/landing/landing.module').then(
                (m) => m.LandingModule,
            ),
    },
    {
        path: 'notfound',
        loadChildren: () =>
            import('./demo/components/notfound/notfound.module').then(
                (m) => m.NotfoundModule,
            ),
    },
    {
        path: 'studentSignIn',
        loadChildren: () =>
            import('./demo/components/student-sign-in/student-sign-in.module').then(
                (m) => m.StudentSignInModule,
            ),
    },
    {
        path: 'my-contacts',
        loadChildren: () =>
            import('./demo/components/myschool/student/student-profile/my-contacts/my-contacts.module').then(
                (m) => m.MyContactsModule,
            ),
        canActivate: [AuthGuard, PermissionGuard],
    },
    {
        path: 'comingsoon',
        loadChildren: () =>
            import('./demo/components/coming-soon/coming-soon.module').then(
                (m) => m.ComingSoonModule,
            ),
    },
    { path: '**', redirectTo: '/notfound' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
